module.exports = __webpack_public_path__ + "img/left-arrow.6756dda7.svg";